import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, ShieldCheck, Truck } from "lucide-react";
import { fmtDate } from "@/lib/format";

export default function Verify() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/verify/${id}`).then((r) => setData(r.data)).catch((e) => setError(e.response?.data?.detail || "No encontrado"));
  }, [id]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="border-b border-gray-200 bg-white">
        <div className="max-w-4xl mx-auto p-6 flex items-center gap-3">
          <div className="w-10 h-10 bg-white border border-gray-200 flex items-center justify-center p-1">
            <img src="/vetacar-logo.png" alt="VETA CAR" className="w-full h-full object-contain" />
          </div>
          <span className="font-display text-2xl">VETA CAR</span>
          <span className="veta-tag ml-3">Verificación pública</span>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-2xl">
          {error && (
            <div className="border-4 border-red-600 bg-white p-12 text-center" data-testid="verify-error">
              <XCircle size={64} className="text-red-600 mx-auto" strokeWidth={2.5} />
              <h1 className="font-display text-4xl mt-4">Documento No Válido</h1>
              <p className="text-sm text-gray-600 mt-2">{error}</p>
            </div>
          )}

          {data && (
            <div className="border-4 border-green-600 bg-white" data-testid="verify-success">
              <div className="bg-green-50 border-b-4 border-green-600 p-8 text-center">
                <CheckCircle2 size={72} className="text-green-600 mx-auto" strokeWidth={2.5} />
                <p className="veta-tag mt-3 text-green-800">Documento Auténtico</p>
                <h1 className="font-display text-4xl md:text-5xl tracking-tighter mt-2">DOCUMENTO VÁLIDO</h1>
              </div>
              <div className="p-8 space-y-5">
                <p className="text-base text-gray-700 leading-relaxed">
                  Documento válido, emitido por <span className="font-bold text-black">{data.company_name}</span> para la patente{" "}
                  <span className="font-bold font-mono text-black">{data.vehicle_plate}</span> el día{" "}
                  <span className="font-bold text-black">{fmtDate(data.issued_at)}</span>.
                </p>
                <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
                  <div>
                    <p className="veta-tag">Tipo</p>
                    <p className="font-bold text-black mt-1">{data.type}</p>
                  </div>
                  <div>
                    <p className="veta-tag">Patente</p>
                    <p className="font-mono font-bold text-black mt-1" data-testid="verify-plate">{data.vehicle_plate}</p>
                  </div>
                  <div>
                    <p className="veta-tag">Empresa Emisora</p>
                    <p className="font-bold text-black mt-1" data-testid="verify-company">{data.company_name}</p>
                  </div>
                  <div>
                    <p className="veta-tag">Fecha de Emisión</p>
                    <p className="font-bold text-black mt-1">{fmtDate(data.issued_at)}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 pt-4 text-xs text-gray-500">
                  <ShieldCheck size={14} strokeWidth={2.5} /> Verificado por VETA CAR
                </div>
              </div>
            </div>
          )}

          {!data && !error && (
            <div className="border border-gray-200 bg-white p-12 text-center text-gray-500">Verificando...</div>
          )}
        </div>
      </main>
    </div>
  );
}
